import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  SET_CURRENT_STEP,
  SET_PREVIOUS_ROUTE,
  SET_PREVIOUS_ROUTE_PARAMS,
  SET_SIGNUP_STATE
} from '@/utils/store/mutationTypes'
import { ACTIVE_BOXER } from '@/utils/store/getterTypes'
import { Currencies } from '@/enums/general'
import { addLocalCurrency } from '@/utils/general'
import { BoysPrices, MenPrices } from '@/enums/products'
import { PageTransitionNames, RoutesOrderMen, QueryParams, defaultState } from '@/enums/signup'
import { MembershipTypes, TrialDuration } from '@/enums/member'
import { DeliveryTimes } from '@/enums/shipments'
import PolicyLinks from '@/components/PolicyLinks/PolicyLinks'
const Steps = () => import('@/components/Steps')

export default ({ currentStep, previousRoute, previousRouteParams = {} } = {}) => {
  return {
    middleware: 'signupMen',
    components: {
      Steps,
      PolicyLinks
    },
    transition (to, from) {
      const mode = ''
      const transition = { name: PageTransitionNames.left, mode }

      if (from?.name.includes('men-signup-create-account-address') && to?.name.includes('men-signup-create-account-address')) {
        return {}
      }

      if (!from || !from.name) {
        return transition
      }

      const toIndex = RoutesOrderMen.findIndex(routeName => routeName === to.name.replace('lang-', ''))
      const fromIndex = RoutesOrderMen.findIndex(routeName => routeName === from.name.replace('lang-', ''))

      if ((toIndex !== -1 && fromIndex !== -1) && toIndex < fromIndex) {
        transition.name = PageTransitionNames.right
      }

      return transition
    },
    computed: {
      signUpLayoutBoxProps () {
        return {
          activeStep: currentStep,
          steps: this.signupSteps,
          hideSteps: false,
          classes: ['hidden', 'lg:flex', 'lg:mt-10', 'lg:mx-20'],
          class: ''
        }
      },
      signupSummaryBoxProps () {
        return {
          ...this.form,
          activeDesignImage: this.activeBoxer.images,
          boxershortName: this.activeBoxer.name,
          country: this.$t(`Countries.${this.country}`),
          countryCode: this.country
        }
      },
      signupTitleProps () {
        return { name: 'data-qa', value: `signup-step-${currentStep}-title` }
      },
      signupSteps () {
        return [
          {
            icon: 'edit-white'
          },
          {
            icon: 'boxer-multiple-blanc'
          },
          {
            icon: 'face-blanc'
          },
          {
            icon: 'truck-blanc'
          },
          {
            icon: 'checkmark'
          },
          {
            title: this.$t('SignUp.Free'),
            icon: 'boxer-blanc'
          }
        ]
      },
      USPSvariables () {
        const orientationPrices = MembershipTypes.boysoriginals === this.form.membershipType ? BoysPrices : MenPrices

        const countryCode = `${this.locale}-${this.country}`

        return {
          trialDuration: TrialDuration[this.country],
          freePrice: addLocalCurrency(0, countryCode, Currencies[this.country]),
          price: addLocalCurrency(orientationPrices[this.country], countryCode, Currencies[this.country]),
          amount: addLocalCurrency(orientationPrices[this.country], countryCode, Currencies[this.country])
        }
      },
      showConsentVariant () {
        return true
      },
      faqItems () {
        const path = 'SignUp.StepThree.FaqItems'
        const items = this.$t(path)

        if (!Array.isArray(items)) {
          return []
        }

        const orientationPrices = MembershipTypes.boysoriginals === this.form.membershipType ? BoysPrices : MenPrices

        const countryCode = `${this.locale}-${this.country}`

        const variables = {
          price: addLocalCurrency(orientationPrices[this.country], countryCode, Currencies[this.country]),
          trialDuration: TrialDuration[this.country],
          earliest: DeliveryTimes[this.country].earliest,
          latest: DeliveryTimes[this.country].latest
        }

        return items.map((_, i) => ({
          title: this.$t(`${path}[${i}].title`, variables),
          description: this.$t(`${path}[${i}].description`, variables)
        }))
      },
      ...mapGetters('signup', {
        activeBoxer: ACTIVE_BOXER
      }),
      ...mapState('signup', {
        currentStep: state => state.currentStep,
        previousRoute: state => state.previousRoute,
        previousRouteParams: state => state.previousRouteParams,
        form: state => state.form
      }),
      ...mapState('app', {
        country: state => state.country,
        locale: state => state.locale
      })
    },
    created () {
      if (!Number.isNaN(Number(currentStep)) && (this.currentStep !== currentStep)) {
        this.setCurrentStep({ step: currentStep })
      }

      const previousRouteParam = this.$route.query[QueryParams.previousroute]

      if (previousRouteParam) {
        this.setPreviousRoute({ route: previousRouteParam })
      } else if (previousRoute !== undefined && (this.previousRoute !== previousRoute)) {
        this.setPreviousRoute({ route: previousRoute })
        this.setPreviousRouteParams({ params: previousRouteParams })
      }
    },
    methods: {
      onBackButtonClick () {
        this.$router.push(this.$i18n.localePath({ name: this.previousRoute, params: this.previousRouteParams }))
      },
      saveSignupSummaryBoxPropsToLocalstorage () {
        const data = { ...this.signupSummaryBoxProps, backgroundColor: 'transparent' }

        window.localStorage.setItem('signupSummaryBoxProps', JSON.stringify(data))
      },
      resetSignupState () {
        this.setSignupState(defaultState)
      },
      setupNextRouteRedirect (name) {
        this.setNextRoute({ route: this.$i18n.getCurrentLocalePath() })
        this.$router.push(this.$i18n.localePath({ name }))
      },
      ...mapMutations('signup', {
        setCurrentStep: SET_CURRENT_STEP,
        setPreviousRoute: SET_PREVIOUS_ROUTE,
        setPreviousRouteParams: SET_PREVIOUS_ROUTE_PARAMS
      }),
      ...mapMutations('signup', {
        setSignupState: SET_SIGNUP_STATE
      })
    }
  }
}
